<template>
  <div class="basic">
    <div class="basic-task">
      <div v-for="(item, index) in taskList" :key="index" class="task-one"
        :class="item.process ? 'finished' : index === 0 ? 'ing' : ''">
        {{ index + 1 }}.{{ item.nameEn }}<br />
        <span style="padding-left: 10px;width: 100%;">
          ({{ item.name }})
        </span>
        <div class="box">
          <div v-if="!item.process"></div>
          <i v-else class="icon iconfont icon-duigou" style="color: #fff"></i>
        </div>
      </div>
      <div class="line"></div>
    </div>
    <Form ref="formInline" :model="formInline" style="width: 100%" :rules="ruleInline" label-position="top"
      @on-validate="getvalidate">

      <div style="display: flex;margin-bottom: 20px;position: relative;justify-content: center; " v-if="false">
        <span class="req">*</span>

        <div class="license-img">
          <template v-if="uploadList5 && uploadList5.length">
            <div class="license-img-list" v-for="(item, index) in uploadList5" :key="'upload' + index"
              style="width: 230px;height: 84px;display: flex;justify-content: center;">
              <template v-if="item.status === 'finished'">
                {{ item.name }}
                <span class="line"></span>
                <span @click="handleRemoveByArr5(item)">Delete/删除</span>
              </template>
            </div>
          </template>
        </div>
        <div class="downLoad" @click="getfile()">
          <a href="javascript:"> Download Booth Application Form/点击下载展位申请表</a>
        </div>
      </div>
      <div class="basic-header">
        <p>Booth Application/参展申请</p>
        <span></span>
        <p>General Information/基本信息</p>
      </div>

      <!-- 公司名称 -->
      <div class="basic-name">
        <Row :gutter="10">
          <Col span="15">
          <div style="display: flex">
            <FormItem label="">
            </FormItem>
            <FormItem label="Company Name/公司名称" prop="companyName" id="companyName">
              <Input type="text" v-model="formInline.companyName" placeholder="Please enter Company name/请输入公司名称"
                style="width: 560px;" maxlength="100" />
            </FormItem>
          </div>
          </Col>
          <Col span="9">
          <FormItem prop="companyNameShort" label="Brand Name (For Propaganda)/品牌名称(宣传用)">
            <Input type="text" placeholder="Please enter Brand name/品牌名称(宣传用)" v-model="formInline.companyNameShort"
              style="width: 270px" maxlength="100" />
          </FormItem>
          </Col>
        </Row>
      </div>

      <!-- 公司地址 -->
      <div class="basic-address">
        <Row :gutter="10">
          <Col span="6">
          <FormItem label="Country/公司地址" required>
            <div style="display: flex">
              <FormItem prop="country" id="country">
                <Select style="width: 230px" v-if="countryList" v-model="formInline.country"
                  placeholder='Please select your Country/请选择公司地址' filterable>
                  <Option v-for="(item, index) in countryList" :value="item.pinyin" :label="$t(item.pinyin)" :key="index">
                    {{
                      item.pinyin }}/{{ item.name }}</Option>
                </Select>
              </FormItem>
            </div>
          </FormItem>
          </Col>

          <Col span="18">
          <div style="display: flex">
            <FormItem prop="address" id="address" label="Company Address/详细地址" required>
              <Input type="text" placeholder="Please enter Company Address/请输入详细地址" v-model="formInline.address"
                style="width: 565px; margin-right: 50px" maxlength="400" />
            </FormItem>
            <FormItem prop="telephone" id="telephone" label="Telephone/公司座机">
              <Input type="text" placeholder="Please enter Telephone/请输入公司座机" v-model="formInline.telephone"
                style="width: 230px" maxlength="100" />
              <p style="line-height: 1;font-size: 12px;color: #808080;margin-top: 6px;">
                example/示例:+86-10-84666617
              </p>
            </FormItem>
          </div>
          </Col>
        </Row>
      </div>

      <!-- 公司电话 -->
      <div class="basic-phone">
        <Row :gutter="10">
          <Col span="12">
          <div style="display: flex">
            <FormItem label="Website/公司网址" prop="website" id="website">
              <Input type="text" placeholder="Please enter Website/请输入公司网址" v-model="formInline.website"
                style="width: 270px; margin-right: 10px" maxlength="100" />
            </FormItem>

          </div>
          </Col>
          <Col span="12">
          <div style="display: flex">
            <FormItem label="Asset Type/资产类型" prop="typeAsset" id="typeAsset">
              <Select v-model="formInline.typeAsset" style="width: 270px; margin-right: 10px" @on-change="getselect"
                placeholder="Please select Asset Type/请选择资产类型">
                <Option v-for="item in BusinessList" :value="item.nameEn + '/' + item.name"
                  :key="item.nameEn + '/' + item.name">
                  {{ item.nameEn }}/{{ item.name }}</Option>
              </Select>
            </FormItem>
            <FormItem label="Business Type/企业经营类型" prop="typeBusiness" id="typeBusiness">
              <Select v-model="formInline.typeBusiness" style="width: 270px"
                placeholder="Please select your Business type/请选择企业经营类型" v-if="isOption">
                <Option v-for="item in NatureList" :value="item.nameEn + '/' + item.name"
                  :key="item.nameEn + '/' + item.name">{{
                    item.nameEn }}/{{ item.name }}</Option>
              </Select>
              <Input v-else placeholder="Please enter Business Type/请输入企业经营类型" v-model="formInline.typeBusiness"
                style="width: 270px" maxlength="200"></Input>
            </FormItem>
          </div>
          </Col>
        </Row>
      </div>

      <!-- 营业执照 -->
      <div class="basic-license">
        <Row :gutter="10">
          <Col span="12">
          <FormItem label="Company Logo/公司logo">
            <div style="display: flex; position: relative">
              <Upload ref="upload" :show-upload-list="false" :default-file-list="defaultList2"
                :on-success="handleSuccess2" :format="['jpg', 'png']" :max-size="5120" :headers="formHeaders"
                :on-format-error="handleFormatError2" :on-exceeded-size="handleMaxSize2"
                :before-upload="handleBeforeUpload2" :action="uploadUrl" style="margin-right: 10px">
                <div class="upload-btn">Upload Company Logo/上传公司logo</div>
              </Upload>
              <p style="position: absolute;left: 0;top: 34px;font-size: 12px;color: #808080;">
                jpg,png only, within 5M
              </p>
              <div class="license-img">
                <template v-if="uploadList2 && uploadList2.length">
                  <div class="license-img-list" v-for="(item, index) in uploadList2" :key="'upload' + index">
                    <template v-if="item.status === 'finished'">
                      <span class="name" :title="item.name">
                        {{ item.name }}
                      </span>
                      <span class="line"></span>
                      <span @click="handleRemoveByArr2(item)">Delete</span>
                    </template>
                  </div>
                </template>
              </div>
            </div>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="Company registration certificate/营业执照">
            <div style="display: flex; position: relative">
              <Upload ref="upload" :show-upload-list="false" :default-file-list="defaultList" :on-success="handleSuccess"
                :format="['jpg', 'png', 'pdf']" :max-size="5120" :headers="formHeaders"
                :on-format-error="handleFormatError" :on-exceeded-size="handleMaxSize" :before-upload="handleBeforeUpload"
                :action="uploadUrl" style="margin-right: 10px">
                <div class="upload-btn">Upload Registration/上传营业执照</div>
              </Upload>
              <p style="position: absolute;left: 0;top: 34px;font-size: 12px;color: #808080;">
                jpg,png only, within 5M
              </p>
              <div class="license-img">
                <template v-if="uploadList && uploadList.length">
                  <div class="license-img-list" v-for="(item, index) in uploadList" :key="'upload' + index">
                    <template v-if="item.status === 'finished'">
                      <span class="name" :title="item.name">
                        {{ item.name }}
                      </span>
                      <span class="line"></span>
                      <span @click="handleRemoveByArr(item)">Delete</span>
                    </template>
                  </div>
                </template>
              </div>
            </div>
          </FormItem>
          </Col>
        </Row>
      </div>

      <!-- 企业类型 -->
      <div class="basic-export">
        <Row :gutter="10">
          <Col span="12">
          <FormItem label="Whether Listed Company/是否上市公司" required>
            <iSwitch size="large" @on-change="listedChange" style="margin-right: 14px" v-model="isListed">
              <span slot="open">Yes</span>
              <span slot="close">No</span>
            </iSwitch>
            <template v-if="isListed">
              <Input type="text" placeholder="Please enter securities exchange/请输入证券交易所"
                v-model="formInline.stockExchange" style="width: 235px; margin-right: 10px" />
              <Input type="text" placeholder="Please enter stock ticker/请输入股票代码" v-model="formInline.stockCode"
                style="width: 235px" />
            </template>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="Whether Fortune Global 500/是否隶属于世界500强" required>
            <iSwitch size="large" @on-change="topNoChange" style="margin-right: 14px" v-model="isTop500">
              <span slot="open">Yes</span>
              <span slot="close">No</span>
            </iSwitch>
            <Input v-if="isTop500" type="text" placeholder="Please enter ranking/请输入排名" v-model="formInline.topNo"
              style="width: 480px" />
          </FormItem>
          </Col>
        </Row>
      </div>

      <!-- 展会联系人 -->
      <div class="basic-link">
        <FormItem label="Contact Person/展会联系人" required> </FormItem>
      </div>
      <div class="basic-links">
        <Row :gutter="10">
          <Col span="12">
          <div style="display: flex">
            <FormItem label=" Name/姓名" prop="linkMan" id="linkMan">
              <Input type="text" placeholder="Please enter Name/请输入姓名" v-model="formInline.linkMan"
                style="width: 270px; margin-right: 10px" />
            </FormItem>
            <FormItem label="Position/职务" prop="linkTitle" id="linkTitle">
              <Input type="text" placeholder="Please enter Position/请输入职务" v-model="formInline.linkTitle"
                style="width: 270px" />
            </FormItem>
          </div>
          </Col>
          <Col span="12">
          <div style="display: flex">
            <FormItem label="Landline/座机" prop="linkMob" id="linkMob">
              <Input type="text" placeholder="Please enter contact Landline/座机" v-model="formInline.linkMob"
                style="width: 270px; margin-right: 10px" />
            </FormItem>
            <FormItem label="Contact Number/手机" prop="linkTelephone" id="linkTelephone">
              <Input type="text" placeholder="Please enter contact Contact number/请输入手机"
                v-model="formInline.linkTelephone" style="width: 270px; margin-right: 10px" />
            </FormItem>
          </div>
          </Col>
        </Row>
        <Row :gutter="10">
          <Col span="12">
          <div style="display: flex">
            <FormItem label="Email/邮箱" prop="linkEmail" id="linkEmail">
              <Input type="text" placeholder="Please enter contact Email/邮箱" v-model="formInline.linkEmail"
                style="width: 270px; margin-right: 10px" />
            </FormItem>
            <FormItem label="QQ" prop="linkQQ" id="linkQQ">
              <Input type="text" placeholder="Please enter QQ/请输入QQ" v-model="formInline.linkQQ"
                style="width: 270px; margin-right: 10px" />
            </FormItem>
          </div>
          </Col>
        </Row>
      </div>

      <!-- 市场部负责人 -->
      <div class="basic-leader">
        <FormItem label="Marketing Personnel/市场部负责人" required> </FormItem>
        <Button @click="ditto" class="above">Same as above/信息同步</Button>
      </div>
      <div class="basic-leaders">
        <Row :gutter="10">
          <Col span="12">
          <div style="display: flex">
            <FormItem label="Name/姓名" prop="leader" id="leader">
              <Input type="text" placeholder="Please enter Name/请输入姓名" v-model="formInline.leader"
                style="width: 270px; margin-right: 10px" />
            </FormItem>
            <FormItem label="Position/职务" prop="leaderTitle" id="leaderTitle">
              <Input type="text" placeholder="Please enter Position/请输入职务" v-model="formInline.leaderTitle"
                style="width: 270px" />
            </FormItem>
          </div>

          </Col>
          <Col span="12">
          <div style="display: flex">
            <FormItem label="Landline/座机" prop="leaderMob" id="leaderMob">
              <Input type="text" placeholder="Please enter contact landline/座机" v-model="formInline.leaderMob"
                style="width: 270px; margin-right: 10px" />
            </FormItem>
            <FormItem label="Contact Number/手机" prop="leaderTelephone" id="leaderTelephone">
              <Input type="text" placeholder="Please enter contact contact number/请输入手机"
                v-model="formInline.leaderTelephone" style="width: 270px; margin-right: 10px" />
            </FormItem>
          </div>
          </Col>
        </Row>
        <Row :gutter="10">
          <Col span="12">
          <div style="display: flex">
            <FormItem label="Email/邮箱" prop="leaderEmail" id="leaderEmail">
              <Input type="text" placeholder="Please enter contact email/邮箱" v-model="formInline.leaderEmail"
                style="width: 270px; margin-right: 10px" />
            </FormItem>
            <FormItem label="QQ" prop="leaderQQ" id="leaderQQ">
              <Input type="text" placeholder="Please enter QQ/请输入QQ" v-model="formInline.leaderQQ"
                style="width: 270px; margin-right: 10px" />
            </FormItem>
          </div>
          </Col>
        </Row>
      </div>

      <!-- 开票信息 -->
      <div class="basic-invoiceType">
        <p style="font-size: 18px;">VAT Invoice(中国增值税发票)</p>
        <Checkbox v-model="isInvoice"><span>No invoice required / 暂不填写</span></Checkbox>
      </div>
      <div class="basic-invoices" v-if="!isInvoice">
        <Row :gutter="10">
          <Col span="12">
          <div style="display: flex">
            <FormItem label="发票抬头" prop="invoiceTitle" id="invoiceTitle">
              <Input type="text" placeholder="请输入发票抬头" v-model="formInline.invoiceTitle"
                style="width: 270px; margin-right: 10px" />
            </FormItem>
            <FormItem label="税号" prop="invoiceCode" id="invoiceCode">
              <Input type="text" placeholder="请输入税号" v-model="formInline.invoiceCode" style="width: 270px" />
            </FormItem>
          </div>
          </Col>
          <Col span="12">
          <div style="display: flex">
            <FormItem label="单位地址" prop="invoiceAddress" id="invoiceAddress">
              <Input type="text" placeholder="请输入单位地址" v-model="formInline.invoiceAddress"
                style="width: 270px; margin-right: 10px" />
            </FormItem>
            <FormItem label="电话号码" prop="invoiceTelephone" id="invoiceTelephone">
              <Input type="text" placeholder="请输入电话号码" v-model="formInline.invoiceTelephone" style="width: 270px" />
            </FormItem>
          </div>
          </Col>
        </Row>
        <Row :gutter="10">
          <Col span="12">
          <div style="display: flex">
            <FormItem label="开户银行" prop="invoiceBank" id="invoiceBank">
              <Input type="text" v-model="formInline.invoiceBank" style="width: 270px; margin-right: 10px"
                placeholder="请输入开户银行" />
            </FormItem>
            <FormItem label="银行账户" prop="invoiceBankAccount" id="invoiceBankAccount">
              <Input type="text" v-model="formInline.invoiceBankAccount" placeholder="请输入银行账户" style="width: 270px" />
            </FormItem>
          </div>
          </Col>
          <Col span="12">
          <div style="display: flex">
            <FormItem label="开票类型" prop="invoiceType" id="invoiceType">
              <RadioGroup v-model="formInline.invoiceType">
                <Radio label="增值税专票">
                  <span>专票</span>
                </Radio>
                <Radio label="增值税普票">
                  <span>普票</span>
                </Radio>
              </RadioGroup>
            </FormItem>
          </div>
          </Col>

        </Row>
      </div>

      <div class="basic-btn">
        <Button type="primary" size="large" @click="handleSubmit('formInline')" :loading="loading">Submit and Proceed
          <br />
          提交并下一步</Button>
      </div>
    </Form>
  </div>
</template>

<script>
import config from "@assets/config.json";
import { mapGetters, mapActions } from "vuex";
import { validator } from "@/other/validatorEn";
import city from "@static/city.json";
// import country from "@static/country.json";
export default {
  name: "basic", // 参展申请 - 基本信息
  data () {
    return {
      cityList1: [],
      cityList2: [],
      cityList3: [],
      model0: "",
      model2: "",
      model3: "",
      model1: "",
      sheng: [],
      shi: [],
      qu: [],
      city: city,
      taskList: [],
      speenInfo: null,
      loading: false,
      formInline2: {
        companyName: "上海连战",
        companyNameEn: "lianzhan",
        companyNameShort: "连战",
        country: "",
        address: "金沙江西路1555路慧创国际16号2层",
        telephone: "861084666617",
        website: "https://www.chinadentalshow.com/Information/?cid=132",
        typeAsset: "股份有限公司",
        typeBusiness: "生产制造",
        stockExchange: "", // 证件交易所
        stockCode: "", // 股票代码
        topNo: "", // 世界排名
        linkMan: "李某",
        linkTitle: "前端",
        linkMob: "86-1084666617",
        linkEmail: "2624006658@qq.com",
        linkTelephone: '13122959676',
        linkQQ: "2624006658",
        leader: "李某",
        leaderTitle: "前端",
        leaderMob: "86-1084666617",
        leaderEmail: "2624006658@qq.com",
        leaderTelephone: '13122959676',
        leaderQQ: "2624006658",
        invoiceTitle: "慕渊（上海）智能科技有限公司",
        invoiceCode: "91310118MA1JM12CX7",
        invoiceAddress: "金沙江西路1555路慧创国际16号2层",
        invoiceTelephone: "13122959676",
        invoiceBank: "招商银行",
        invoiceBankAccount: "6225758214779869",
        invoiceType: "增值税专票",//发票类型
        FileApplyTable: "",
        PostAddr: "金沙江西路1555路慧创国际16号2层",//发票地址
        PostMan: "李扬",//联系人
        PostTel: "13122959676",//联系电话
      },
      formInline: {
        companyName: "",
        companyNameEn: "",
        companyNameShort: "",
        country: "",
        address: "",
        telephone: "",
        website: "",
        typeAsset: "",
        typeBusiness: "",
        stockExchange: "", // 证件交易所
        stockCode: "", // 股票代码
        topNo: "", // 世界排名
        linkMan: "",
        linkTitle: "",
        linkMob: "",
        linkEmail: "",
        linkTelephone: "",
        linkQQ: "",
        leader: "",
        leaderTitle: "",
        leaderMob: "",
        leaderEmail: "",
        leaderTelephone: "",
        leaderQQ: "",
        invoiceTitle: "",
        invoiceCode: "",
        invoiceAddress: "",
        invoiceTelephone: "",
        invoiceBank: "",
        invoiceBankAccount: "",
        invoiceType: "增值税专票",//发票类型
        FileApplyTable: "",
        PostAddr: "",//发票地址
        PostMan: "",//联系人
        PostTel: "",//联系电话
      },
      ruleInline: {
        companyName: [
          {
            required: true,
            message: "Please enter company name/请输入公司名称",
            trigger: "change",
          },
        ],
        companyNameShort: [
          {
            required: true,
            message: "Please enter brand name (For Propaganda)/品牌名称(宣传用)",
            trigger: "change",
          },
        ],
        website: [
          { required: true, message: "Please enter website/请输入公司网址", trigger: "change" },
        ],
        country: [
          { required: true, message: "Please enter country/公司地址", trigger: "change" },
        ],
        address: [
          {
            required: true,
            message: "Please enter Detail address/请输入详细地址",
            trigger: "change",
          },
        ],
        telephone: [
          {
            required: true,
            message: "Please enter Telephone/请输入电话号",
            trigger: "change",
          },
        ],
        typeAsset: [
          {
            required: true,
            message: "Please select Asset Type/请选择资产类型",
            trigger: "change",
          },
        ],
        typeBusiness: [
          {
            required: true,
            message: "Please select Business Type/请选择企业经营类型",
            trigger: "change",
          },
        ],
        linkMan: [
          { required: true, message: "Please enter Name/请输入姓名", trigger: "change" },
        ],
        linkTitle: [
          { required: true, message: "Please enter Position/请输入职务", trigger: "change" },
        ],
        linkMob: [
          {
            required: true,
            message: "Please enter contact landline/座机",
            trigger: "change",
          },
        ],
        linkTelephone: [
          {
            required: true,
            message: "Please enter contact contact number/请输入手机",
            trigger: "blur",
          },
          ...validator.phone,
        ],
        linkEmail: [
          {
            required: true,
            message: "Please enter contact Email/邮箱",
            trigger: "change",
          },
          ...validator.email
        ],
        leader: [
          { required: true, message: "Please enter Name/请输入姓名", trigger: "change" },
        ],
        leaderTitle: [
          { required: true, message: "Please enter Position/请输入职务", trigger: "change" },
        ],
        leaderMob: [
          {
            required: true,
            message: "Please enter contact landline/座机",
            trigger: "change",
          },
        ],
        leaderTelephone: [
          {
            required: true,
            message: "Please enter contact contact number/请输入手机",
            trigger: "blur",
          },
          ...validator.phone,
        ],
        leaderEmail: [
          {
            required: true,
            message: "Please enter contact Email/邮箱",
            trigger: "change",
          },
          ...validator.email
        ],
        invoiceTitle: [
          {
            required: true,
            message: "请输入发票抬头",
            trigger: "change",
          },
        ],
        invoiceCode: [
          { required: true, message: "请输入税号", trigger: "change" },
        ],
        invoiceAddress: [
          {
            required: true,
            message: "请输入单位地址",
            trigger: "change",
          },
        ],
        invoiceTelephone: [
          {
            required: true,
            message: "请输入电话号码",
            trigger: "change",
          },
        ],
        invoiceBank: [
          {
            required: true,
            message: "请输入开户银行",
            trigger: "change",
          },
        ],
        invoiceBankAccount: [
          {
            required: true,
            message: "请输入银行账户",
            trigger: "change",
          },
        ],
        invoiceType: [
          { required: true, message: "请选择开票类型", trigger: "change" },
        ],
        PostAddr: [
          { required: true, message: "请输入邮编地址", trigger: "change" }
        ],
        PostMan: [
          { required: true, message: "请输入联系人", trigger: "change" }
        ],
        PostTel: [
          { required: true, message: "请输入联系电话", trigger: "change" }
        ]
      },
      BusinessList: [],
      NatureList: [],
      AreaList: [],
      defaultList: [],
      uploadList: [],
      uploadName: "",

      defaultList2: [],
      uploadList2: [],
      uploadName2: "",

      isExport: true, // 是否是外销企业
      isListed: true, // 是否是上市公司
      isTop500: false, // 是否是世界五百强
      isMicroEnterprise: false, // 是否为小微企业
      isHighTech: true, // 是否为高新科技型企业
      isInvoice: true, // 有/无 开票信息

      defaultList3: [],
      uploadList3: [],
      uploadName3: "",

      defaultList4: [],
      uploadList4: [],
      uploadName4: "",

      defaultList5: [],
      uploadList5: [],
      uploadName5: "",
      basicInfo: null,
      validateList: [],
      ElepropName: "", //验证错误的prop名
      companyId: "", //公司ID
      isOption: true, //企业经营类型是否是选择框
    //   countryList: country, //国家数组
      countryList: [], //国家数组
    };
  },
  computed: {
    ...mapGetters({
      formHeaders: "commonFill/getFormHeaders",
      uploadUrl: "commonFill/getUploadUrl",
      exhibitionId: "commonFill/getExhibitionId",
      company: "commonFill/getCompany",
    }),
    userId () {
      return this.$route.query.userId;
    },
    applyCompanyId () {
      return this.$route.query.applyCompanyId;
    },
    applyCompanyOrderId () {
      return this.$route.query.applyCompanyOrderId;
    },
    uploadUrl2 () {
      return `${config.api.reqApi}/api/upload/files`;
    },

  },
  created () {
    if (!this.IsPC()) {
      this.$router.push(`/basic/mobileEn`);
    }
    this.init();
  },
  async mounted () {
     this.countryList = await this.getAllAddress();
      
    var city = this.city;
    for (var i in city) {
      var obj = {
        value: city[i].name,
        id: city[i].id,
      };
      this.cityList1.push(obj);
      this.shi.push(city[i].child);
    }
  },
  methods: {
    ...mapActions({
      getApplyFlow: "commonFill/getApplyFlow",
      getApplyFlowSpeed: "commonFill/getApplyFlowSpeed",
      getNature: "commonFill/getNature",
      getBusinessType: "commonFill/getBusinessType",
      addApplyCompany: "commonFill/addApplyCompany",
      editApplyCompany: "commonFill/editApplyCompany",
      getAreaAll: "commonFill/getAreaAll",
      getCountryByArea: "commonFill/getCountryByArea",
      getApplyCompanyBasic: "commonFill/getApplyCompanyBasic",
      getJoinCompany: "commonFill/getJoinCompany",
      getYesLink: "commonFill/getYesLink",
      getApplyConfig: "commonFill/getApplyConfig", //获取文件
      getwordfileEn: "commonFill/getwordfileTermEn", //下载文档
      getCountry: "commonFill/getCountry",
      getCompanyBasicInfo: "commonFill/getCompanyBasicInfo",//获取公司申报的信息
       getAllAddress:"getAllAddress"

    }),
    IsPC () {
      var userAgentInfo = navigator.userAgent;
      var Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    },
    getvalidate (prop, status, error) {
      if (status == false) {
        let opt = {
          prop: prop,
          status: status,
        };
        this.validateList.push(opt);
      }
    },
    deteleObject (obj) {
      var uniques = [];
      var stringify = {};
      for (var i = 0; i < obj.length; i++) {
        var keys = Object.keys(obj[i]);
        keys.sort(function (a, b) {
          return Number(a) - Number(b);
        });
        var str = "";
        for (var j = 0; j < keys.length; j++) {
          str += JSON.stringify(keys[j]);
          str += JSON.stringify(obj[i][keys[j]]);
        }
        if (!stringify.hasOwnProperty(str)) {
          uniques.push(obj[i]);
          stringify[str] = true;
        }
      }
      uniques = uniques;
      return uniques;
    },
    async init () {
      // 流程
      let taskList = await this.getApplyFlow();
      this.taskList = taskList;
      // 申请中的
      if (this.applyCompanyId) {
        let info = await this.getApplyFlowSpeed(this.applyCompanyId);
        if (info && info.info) {
          this.speenInfo = info.info;
          if (this.taskList && this.taskList.length > 0) {
            this.taskList.map((c) => {
              if (this.speenInfo && this.speenInfo.speed >= c.speed) {
                c.process = true;
              }
            });
          }
        }

        //获取基本信息
        let basicInfo = await this.getApplyCompanyBasic(this.applyCompanyId);
        this.basicInfo = basicInfo;
        if (!basicInfo) return;
        this.formInline.companyName = basicInfo.companyName || '';
        this.formInline.companyNameEn = basicInfo.companycompanyNameEn;
        this.formInline.companyNameShort = basicInfo.companyNameShort;
        this.formInline.country = basicInfo.country;
        this.formInline.address = basicInfo.address;
        this.formInline.telephone = basicInfo.telephone;
        this.formInline.telephone = basicInfo.telephone;
        this.formInline.website = basicInfo.website;
        this.formInline.typeAsset = basicInfo.typeAsset;
        this.formInline.typeBusiness = basicInfo.typeBusiness;
        let fileApplyTable = JSON.parse(basicInfo.fileApplyTable);
        if (fileApplyTable && fileApplyTable.url) {
          this.uploadList5.push(fileApplyTable);
        }
        if (basicInfo.imgBusinessLicense) {
          let imgBusinessLicense = JSON.parse(basicInfo.imgBusinessLicense);
          if (imgBusinessLicense.url) {
            this.uploadList.push(imgBusinessLicense);
          }
        }
        if (basicInfo.imgLogo) {
          let imgLogo = JSON.parse(basicInfo.imgLogo);
          if (imgLogo && imgLogo.url) {
            this.uploadList2.push(imgLogo);
          }
        }
        if (basicInfo.isExportSales === "False") {
          this.isExport = false;
        } else {
          this.isExport = true;
        }
        if (basicInfo.isListed === "False") {
          this.isListed = false;
        } else {
          this.isListed = true;
        }
        this.formInline.stockExchange = basicInfo.listedExchange;
        this.formInline.stockCode = basicInfo.listedCode;

        if (basicInfo.isTop500 === "False") {
          this.isTop500 = false;
        } else {
          this.isTop500 = true;
        }
        this.formInline.topNo = basicInfo.topNo;

        if (basicInfo.isMicroEnterprise === "False") {
          this.isMicroEnterprise = false;
        } else {
          this.isMicroEnterprise = true;
        }
        if (basicInfo.isHighTech === "False") {
          this.isHighTech = false;
        } else {
          this.isHighTech = true;
        }
        this.formInline.linkMan = basicInfo.linkMan;
        this.formInline.linkTitle = basicInfo.linkTitle;
        this.formInline.linkMob = basicInfo.linkMob;
        this.formInline.linkEmail = basicInfo.linkEmail;
        this.formInline.linkTelephone = basicInfo.linkTelephone;
        this.formInline.leader = basicInfo.leader;
        this.formInline.leaderTitle = basicInfo.leaderTitle;
        this.formInline.leaderMob = basicInfo.leaderMob;
        this.formInline.leaderEmail = basicInfo.leaderEmail;
        this.formInline.leaderTelephone = basicInfo.leaderTelephone;
        if (basicInfo.isInvoice === "False" || basicInfo.isInvoice === 'False') {
          this.isInvoice = false;
        } else {
          this.isInvoice = true;
        }
        this.formInline.invoiceTitle = basicInfo.invoiceTitle;
        this.formInline.invoiceCode = basicInfo.invoiceCode;
        this.formInline.invoiceAddress = basicInfo.invoiceAddress;
        this.formInline.invoiceTelephone = basicInfo.invoiceTelephone;
        this.formInline.invoiceBank = basicInfo.invoiceBank;
        this.formInline.invoiceBankAccount = basicInfo.invoiceBankAccount;
        this.formInline.invoiceType = basicInfo.invoiceType
        this.formInline.PostAddr = basicInfo.postAddr
        this.formInline.PostMan = basicInfo.postMan
        this.formInline.PostTel = basicInfo.postTel

      }

      // 已登录的
      if (this.userId) {
        let company = await this.getJoinCompany(this.userId);
        if (company) {
          let data = await this.getCompanyBasicInfo(company.id)
          if (!data) {
            this.formInline.companyName = company.companyName;
            this.formInline.companyNameEn = company.companyNameEn;
            this.formInline.companyNameShort = company.companyNameShort;
            this.formInline.country = company.country;
            this.formInline.address = company.address;
            this.formInline.website = company.website;
            this.formInline.typeAsset = company.businessType;
            this.formInline.typeBusiness = company.nature;
            this.companyId = company.id;
            if (company.businessLicenses) {
              this.uploadList.push({
                name: "营业执照",
                url: company.businessLicenses,
                status: "finished",
              });
            }
            if (company.logo) {
              this.uploadList2.push({
                name: "公司logo",
                url: company.logo,
                status: "finished",
              });
            }
          }
          else {
            this.formInline.companyName = data.companyName;
            this.formInline.companyNameEn = data.companycompanyNameEn;
            this.formInline.companyNameShort = data.companyNameShort;

            this.formInline.country = data.country;

            this.formInline.address = data.address;
            this.formInline.telephone = data.telephone;
            this.formInline.website = data.website;
            this.formInline.typeAsset = data.typeAsset;
            this.formInline.typeBusiness = data.typeBusiness;
            let fileApplyTable = JSON.parse(data.fileApplyTable);
            if (fileApplyTable && fileApplyTable.url) {
              this.uploadList5.push(fileApplyTable);
            }
            if (data.imgBusinessLicense) {
              let imgBusinessLicense = JSON.parse(data.imgBusinessLicense);
              if (imgBusinessLicense && imgBusinessLicense.url) {
                this.uploadList.push(imgBusinessLicense);
              }
            }
            if (data.imgLogo) {
              let imgLogo = JSON.parse(data.imgLogo);
              if (imgLogo && imgLogo.url) {
                this.uploadList2.push(imgLogo);
              }
            }
            if (data.isExportSales === "False") {
              this.isExport = false;
            } else {
              this.isExport = true;
            }
            if (data.isListed === "False") {
              this.isListed = false;
            } else {
              this.isListed = true;
            }
            this.formInline.stockExchange = data.listedExchange;
            this.formInline.stockCode = data.listedCode;
            if (data.isTop500 === "False") {
              this.isTop500 = false;
            } else {
              this.isTop500 = true;
            }
            this.formInline.topNo = data.topNo;
            if (data.isMicroEnterprise === "False") {
              this.isMicroEnterprise = false;
            } else {
              this.isMicroEnterprise = true;
            }
            if (data.isHighTech === "False") {
              this.isHighTech = false;
            } else {
              this.isHighTech = true;
            }
            this.formInline.linkMan = data.linkMan;
            this.formInline.linkTitle = data.linkTitle;
            this.formInline.linkMob = data.linkMob;
            this.formInline.linkEmail = data.linkEmail;
            this.formInline.leader = data.leader;
            this.formInline.leaderTitle = data.leaderTitle;
            this.formInline.leaderMob = data.leaderMob;
            this.formInline.leaderEmail = data.leaderEmail;
            if (data.isInvoice === "False" || data.isInvoice === 'False') {
              this.isInvoice = false;
            } else {
              this.isInvoice = true;
            }
            this.formInline.invoiceTitle = data.invoiceTitle;
            this.formInline.invoiceCode = data.invoiceCode;
            this.formInline.invoiceAddress = data.invoiceAddress;
            this.formInline.invoiceTelephone = data.invoiceTelephone;
            this.formInline.invoiceBank = data.invoiceBank;
            this.formInline.invoiceBankAccount = data.invoiceBankAccount;
            this.formInline.invoiceType = data.invoiceType
            this.formInline.PostAddr = data.postAddr
            this.formInline.PostMan = data.postMan
            this.formInline.PostTel = data.postTel
          }
        }
      }

      let area = await this.getAreaAll();
      if (area && area.length > 0) {
        area.map((c) => {
          c.value = c.name;
          c.label = c.name;
          c.loading = false;
          c.children = [];
        });
        this.AreaList = area;
      }

      let BusinessList = await this.getNature();
      console.log('BusinessList', BusinessList);
      if (BusinessList) {
        this.BusinessList = BusinessList;
      }

      let NatureList = await this.getBusinessType();
      console.log('NatureList', NatureList);
      if (NatureList) {
        this.NatureList = NatureList;
      }
    },
    async handleSubmit (name) {
      let valid = await this.validForm(name);
      if (!valid) {
        this.validateList = this.deteleObject(this.validateList);
        for (let i = 0; i < this.validateList.length; i++) {
          if (this.validateList[i].status == false) {
            this.ElepropName = this.validateList[i].prop;
            break;
          }
        }
        console.log(this.validateList, " this.ElepropName");
        Element.prototype.documentOffsetTop = function () {
          return (
            this.offsetTop +
            (this.offsetParent ? this.offsetParent.documentOffsetTop() : 0)
          );
        };
        let top =
          document.getElementById(this.ElepropName).documentOffsetTop() -
          window.innerHeight / 2;
        window.scrollTo(0, top);
        this.validateList = [];
        return;
      }
      // logo
      let imgLogo = "";
      // if (this.uploadList2 && this.uploadList2.length) {
      //   imgLogo = this.uploadList2[0];
      // } else {
      //   this.$Message.error("Please enter upload company Logo/请上传公司logo");
      //   return;
      // }

      // 营业执照
      let imgBusinessLicense = "";
      // if (this.uploadList && this.uploadList.length) {
      //   imgBusinessLicense = this.uploadList[0];
      // } else {
      //   this.$Message.error("Please enter upload registration/请上传营业执照");
      //   return;
      // }

      let exportSalesCountry = "";
      if (this.isExport) {
        if (
          this.formInline.exportSalesArea &&
          this.formInline.exportSalesArea.length > 0
        ) {
          this.formInline.exportSalesArea.map((c, i) => {
            if (c.length) {
              if (exportSalesArea.indexOf(c[0]) === -1) {
                if (i !== this.formInline.exportSalesArea.length - 1) {
                  exportSalesArea += c[0] + ",";
                } else {
                  exportSalesArea += c[0];
                }
              }
            }
          });
        }
      }

      // 是否上市
      if (this.isListed) {
        if (!this.formInline.stockExchange) {
          this.$Message.error("Please enter securities exchange/请输入证件交易所");
          return;
        }
        if (!this.formInline.stockCode) {
          this.$Message.error("Please enter stock ticker/请输入股票代码");
          return;
        }
      }
      // 有/暂不填写
      let invoiceTitle = "";
      let invoiceCode = "";
      let invoiceAddress = "";
      let invoiceTelephone = "";
      let invoiceBank = "";
      let invoiceBankAccount = "";
      let invoiceType = "";
      let postAddr = "";
      let postMan = "";
      let postTel = ""
      if (!this.isInvoice) {
        invoiceTitle = this.formInline.invoiceTitle;
        invoiceCode = this.formInline.invoiceCode;
        invoiceAddress = this.formInline.invoiceAddress;
        invoiceTelephone = this.formInline.invoiceTelephone;
        invoiceBank = this.formInline.invoiceBank;
        invoiceBankAccount = this.formInline.invoiceBankAccount;
        invoiceType = this.formInline.invoiceType;
        postAddr = this.formInline.PostAddr
        postMan = this.formInline.PostMan
        postTel = this.formInline.PostTel
      } else {
        invoiceTitle = "";
        invoiceCode = "";
        invoiceAddress = "";
        invoiceTelephone = "";
        invoiceBank = "";
        invoiceBankAccount = "";
        invoiceType = "";
        postAddr = ""
        postMan = ''
        postTel = ""
      }

      let req = {
        companyName: this.formInline.companyName,
        companycompanyNameEn: this.formInline.companyNameEn,
        companyId: this.companyId,
        companyNameShort: this.formInline.companyNameShort,
        country: this.formInline.country,
        address: this.formInline.address,
        telephone: this.formInline.telephone,
        website: this.formInline.website,
        typeAsset: this.formInline.typeAsset,
        typeBusiness: this.formInline.typeBusiness,
        imgBusinessLicense: imgBusinessLicense ? JSON.stringify(imgBusinessLicense) : '',
        imgLogo: imgLogo ? JSON.stringify(imgLogo) : '',
        isExportSales: this.isExport, // 是否外销 
        exportSalesCountry: exportSalesCountry,
        isListed: this.isListed, // 是否上市
        listedExchange: this.formInline.stockExchange, // 证件交易所
        listedCode: this.formInline.stockCode, // 股票代码
        isTop500: this.isTop500, // 是否500
        topNo: this.formInline.topNo,
        isMicroEnterprise: this.isMicroEnterprise, // 是否为小微企业 
        isHighTech: this.isHighTech, // 是否为高新科技型企业 
        linkMan: this.formInline.linkMan,
        linkTitle: this.formInline.linkTitle,
        linkMob: this.formInline.linkMob,
        linkQQ: this.formInline.linkQQ,
        linkEmail: this.formInline.linkEmail,
        linkTelephone: this.formInline.linkTelephone,
        leader: this.formInline.leader,
        leaderTitle: this.formInline.leaderTitle,
        leaderMob: this.formInline.leaderMob,
        leaderQQ: this.formInline.leaderQQ,
        leaderEmail: this.formInline.leaderEmail,
        leaderTelephone: this.formInline.leaderTelephone,
        isInvoice: this.isInvoice,
        invoiceTitle: invoiceTitle,
        invoiceCode: invoiceCode,
        invoiceAddress: invoiceAddress,
        invoiceTelephone: invoiceTelephone,
        invoiceBank: invoiceBank,
        invoiceBankAccount: invoiceBankAccount,
        invoiceType: invoiceType,
        postAddr: postAddr,
        postMan: postMan,
        postTel: postTel,
      };
      console.log('报名：', req);
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      if (this.basicInfo) {
        let opt = {
          id: this.basicInfo.id,
          setValues: {
            CompanyName: this.formInline.companyName,
            CompanycompanyNameEn: this.formInline.companyNameEn,
            CompanyId: this.companyId,
            CompanyNameShort: this.formInline.companyNameShort,
            Country: this.formInline.country,
            Address: this.formInline.address,
            Telephone: this.formInline.telephone,
            Website: this.formInline.website,
            TypeAsset: this.formInline.typeAsset,
            TypeBusiness: this.formInline.typeBusiness,
            ImgBusinessLicense: imgBusinessLicense ? JSON.stringify(imgBusinessLicense) : '',
            ImgLogo: imgLogo ? JSON.stringify(imgLogo) : '',
            IsExportSales: this.isExport, // 是否外销 
            ExportSalesCountry: exportSalesCountry,
            IsListed: this.isListed, // 是否上市
            ListedExchange: this.formInline.stockExchange, // 证件交易所
            ListedCode: this.formInline.stockCode, // 股票代码
            IsTop500: this.isTop500, // 是否500
            TopNo: this.formInline.topNo,
            IsMicroEnterprise: this.isMicroEnterprise, // 是否为小微企业 
            IsHighTech: this.isHighTech, // 是否为高新科技型企业 
            LinkMan: this.formInline.linkMan,
            LinkTitle: this.formInline.linkTitle,
            LinkMob: this.formInline.linkMob,
            LinkQQ: this.formInline.linkQQ,
            LinkEmail: this.formInline.linkEmail,
            LinkTelephone: this.formInline.linkTelephone,
            Leader: this.formInline.leader,
            LeaderTitle: this.formInline.leaderTitle,
            LeaderTelephone: this.formInline.leaderTelephone,
            LeaderMob: this.formInline.leaderMob,
            LeaderQQ: this.formInline.leaderQQ,
            LeaderEmail: this.formInline.leaderEmail,
            IsInvoice: this.isInvoice,
            InvoiceTitle: invoiceTitle,
            InvoiceCode: invoiceCode,
            InvoiceAddress: invoiceAddress,
            InvoiceTelephone: invoiceTelephone,
            InvoiceBank: invoiceBank,
            InvoiceBankAccount: invoiceBankAccount,
            InvoiceType: invoiceType,
            PostAddr: postAddr,
            PostMan: postMan,
            PostTel: postTel,
          }
        }
        let bool = await this.editApplyCompany(
          JSON.stringify(opt)
        );
        this.loading = false;
        if (bool && bool.successed) {
          this.$Message.success("Modificated Successfully!/修改成功！");

          if (this.applyCompanyOrderId) {
            this.$router.push("/fillEn/join/entranceEn?applyCompanyId=" + this.applyCompanyId + "&applyCompanyOrderId=" + this.applyCompanyOrderId);
          } else {
            this.$router.push(
              "/fillEn/join/entranceEn?applyCompanyId=" + this.applyCompanyId
            );
          }
        }
      } else {
        let bool = await this.addApplyCompany(JSON.stringify(req));
        this.loading = false;
        if (bool && bool.successed) {
          this.$Message.success("Submit succeeded!/提交成功!");
          this.$router.push("/fillEn/join/entranceEn?applyCompanyId=" + bool.info);
        }
      }
    },
    async loadData (item, callback) {
      item.loading = true;
      let list = await this.getCountryByArea(item.name);
      if (list && list.length > 0) {
        list.map((c) => {
          c.label = c.name;
          c.value = c.name;
        });
        item.children = list;
      } else {
        this.$Message.warning("No more/没有更多了");
      }
      item.loading = false;
      callback();
    },
    validForm (name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          console.log(valid, "valid");
          resolve(valid);
        });
      });
    },

    listedChange (e) {
      if (!e) {
        this.formInline.stockExchange = "";
        this.formInline.stockCode = "";
      }
    },
    topNoChange (e) {
      if (!e) {
        this.formInline.topNo = "";
      }
    },
    handleSuccess (res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList.push({
          name: this.uploadName,
          url: res.list[0],
          status: "finished",
        });
      } else {
        this.uploadName = "";
      }
    },
    handleFormatError (file) {
      this.uploadName = "";
      this.$Notice.warning({
        title: "Incorrect file format/文件格式是不正确的",
        desc: "Please upload image of JPG/PNG/请上传jpg或者png格式的图片",
      });
    },
    handleMaxSize (file) {
      this.uploadName = "";
      this.$Notice.warning({
        title: "File size exceeded the limit/文件大小超过限制",
        desc: "Please upload an image within 5M/请上传小于5M的图片",
      });
    },
    handleBeforeUpload (e) {
      this.uploadName = e.name;
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Notice.warning({
          title: `Upload up to${limitNum} picture`,
        });
      }
      return check;
    },
    handleRemoveByArr (file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    handleSuccess2 (res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList2.push({
          name: this.uploadName2,
          url: res.list[0],
          status: "finished",
        });
      } else {
        this.uploadName2 = "";
      }
    },
    handleFormatError2 (file) {
      this.uploadName2 = "";
      this.$Notice.warning({
        title: "Incorrect file format/文件格式是不正确的",
        desc: "Please upload image of JPG/PNG/请上传jpg或者png格式的图片",
      });
    },

    handleMaxSize2 (file) {
      this.uploadName2 = "";
      this.$Notice.warning({
        title: "File size exceeded the limit/文件大小超过限制",
        desc: "Please upload an image within 5M/请上传小于5M的图片",
      });
    },
    handleBeforeUpload2 (e) {
      this.uploadName2 = e.name;
      const limitNum = 1;
      const check = this.uploadList2.length < limitNum;
      if (!check) {
        this.$Notice.warning({
          title: `Upload up to${limitNum} picture`,
        });
      }
      return check;
    },
    handleRemoveByArr2 (file) {
      const fileList = this.uploadList2;
      this.uploadList2.splice(fileList.indexOf(file), 1);
    },
    handleSuccess3 (res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList3.push({
          name: this.uploadName3,
          url: res.list[0],
          status: "finished",
        });
      } else {
        this.uploadName3 = "";
      }
    },
    handleFormatError3 (file) {
      this.uploadName3 = "";
      this.$Notice.warning({
        title: "Incorrect file format/文件格式是不正确的",
        desc: "Please upload image of JPG/PNG/请上传jpg或者png格式的图片",
      });
    },
    handleMaxSize3 (file) {
      this.uploadName3 = "";
      this.$Notice.warning({
        title: "File size exceeded the limit/文件大小超过限制",
        desc: "Please upload an image within 2M/请上传小于2M的图片",
      });
    },
    handleBeforeUpload3 (e) {
      this.uploadName3 = e.name;
      const limitNum = 5;
      const check = this.uploadList3.length < limitNum;
      if (!check) {
        this.$Notice.warning({
          title: `Upload up to${limitNum} picture`,
        });
      }
      return check;
    },
    handleRemoveByArr3 (file) {
      const fileList = this.uploadList3;
      this.uploadList3.splice(fileList.indexOf(file), 1);
    },
    handleSuccess4 (res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList4.push({
          name: this.uploadName4,
          url: res.list[0],
          status: "finished",
        });
      } else {
        this.uploadName4 = "";
      }
    },
    handleFormatError4 (file) {
      this.uploadName4 = "";
      this.$Notice.warning({
        title: "Incorrect file format/文件格式是不正确的",
        desc: "Please upload image of JPG/PNG/请上传jpg或者png格式的图片",
      });
    },
    handleMaxSize4 (file) {
      this.uploadName4 = "";
      this.$Notice.warning({
        title: "File size exceeded the limit/文件大小超过限制",
        desc: "Please upload an image within 2M/请上传小于2M的图片",
      });
    },
    handleBeforeUpload4 (e) {
      this.uploadName4 = e.name;
      const limitNum = 5;
      const check = this.uploadList4.length < limitNum;
      if (!check) {
        this.$Notice.warning({
          title: `Upload up to${limitNum} picture`,
        });
      }
      return check;
    },
    handleRemoveByArr4 (file) {
      const fileList = this.uploadList4;
      this.uploadList4.splice(fileList.indexOf(file), 1);
    },
    handleSuccess5 (res, file) {
      console.log(res, "ressssssssss");
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList5.push({
          name: this.uploadName5,
          url: res.list[0],
          status: "finished",
        });
      } else {
        this.uploadName4 = "";
      }
    },
    handleFormatError5 (file) {
      this.uploadName4 = "";
      this.$Notice.warning({
        title: "Incorrect file format/文件格式是不正确的",
        desc: "Please upload a PDF/请上传pdf文件",
      });
    },
    handleMaxSize5 (file) {
      this.uploadName5 = "";
      this.$Notice.warning({
        title: "File size exceeded the limit/文件大小超过限制",
        desc: "Please upload an image within 2M/请上传小于2M的文件",
        duration: 0
      });
    },
    handleRemoveByArr5 (file) {
      const fileList = this.uploadList5;
      this.uploadList5.splice(fileList.indexOf(file), 1);
    },
    //点击省得到id找出对应的市 
    change1 (val) {
      console.log(this.formInline.province);
      this.cityList2 = [];
      this.sheng = val; //为得到县储存值
      var city = this.city;
      for (var i in city) {
        if (val == city[i].name) {
          this.sheng = city[i].name;
          var shi = city[i].child;
          for (var j in shi) {
            var obj = {
              value: shi[j].name,
              id: shi[j].id,
            };

            this.cityList2.push(obj);
          }
        }
      }
    },
    //改变市获取区县
    change2 (val2) {
      this.cityList3 = [];
      var val = this.sheng;
      var city = this.city;
      for (var i in city) {
        var shi = city[i].child;
        for (var j in shi) {
          if (val2 == shi[j].name) {
            var qu = shi[j].child;
            console.log(qu);
            this.shi = shi[j].name;
            for (var k in qu) {
              var obj = {
                value: qu[k].name,
                id: qu[k].id,
              };
              this.cityList3.push(obj);
            }
          }
        }
      }
    },
    change3 (val3) {
      this.model3 = val3;
      var city = this.city;
      for (var i in city) {
        var shi = city[i].child;
        for (var j in shi) {
          var qu = shi[j].child;
          for (var k in qu) {
            if (val3 == qu[k].name) {
              this.qu = qu[k].name;
            }
          }
        }
      }
    },
    // 下载申请表
    async getfile () {
      let data1 = await this.getApplyConfig();
      let key1 = data1.fileApplyTableEn.split("key=")[1];
      let opt = {
        key: key1,
        name: data1.fileApplyTableEnName
      }
      await this.getwordfileEn(opt);
    },
    //资产类型选择框变更
    getselect (value) {
      if (value.trim() == 'Others') {
        this.isOption = false;
      } else {
        this.isOption = true;
      }
    },
    //同上按钮
    ditto () {
      this.formInline.leader = this.formInline.linkMan;
      this.formInline.leaderTitle = this.formInline.linkTitle;
      this.formInline.leaderMob = this.formInline.linkMob;
      this.formInline.leaderTelephone = this.formInline.linkTelephone;
      this.formInline.leaderQQ = this.formInline.linkQQ;
      this.formInline.leaderEmail = this.formInline.linkEmail;
    }
  },

};
</script>

<style scoped lang='scss'>
.req {
  display: flex;
  align-items: center;
  margin-right: 10px;
  line-height: 1;
  font-family: SimSun;
  font-size: 14px;
  color: #ed4014;
}

.basic {
  &-task {
    width: 100%;
    margin: 20px 0 50px;
    padding: 0 80px;
    display: flex;
    justify-content: space-between;
    color: #666;
    position: relative;

    .task-one {
      display: flex;
      flex-direction: column;
      align-items: center;
      z-index: 2;

      .box {
        width: 20px;
        height: 20px;
        background-color: #fff;
        box-shadow: 0px 2px 5px 0px rgba(1, 53, 97, 0.5);
        border-radius: 50%;
        margin-top: 10px;

        div {
          width: 14px;
          height: 14px;
          background-color: #8ba5bc;
          border-radius: 50%;
          margin: 3px auto 0;
        }
      }
    }

    .line {
      height: 8px;
      background-color: #d7dee4;
      position: absolute;
      width: 939px;
      left: 150px;
      top: 59px;
      z-index: 1;
    }

    .ing {
      color: rgba(0, 161, 233, 1);

      .box {
        div {
          background-color: rgba(0, 161, 233, 1);
        }
      }
    }

    .finished {
      color: rgba(0, 161, 233, 1);

      .box {
        background-color: rgba(0, 161, 233, 1);
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  &-header {
    width: 100%;
    height: 64px;
    background-color: rgba(0, 161, 233, 1);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;

    p {
      line-height: 64px;
      font-size: 20px;
    }

    span {
      width: 30px;
      height: 1px;
      background-color: #fff;
      margin: 0 15px;
    }
  }

  &-name {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-address {
    padding: 30px 0 10px 30px;
    background-color: #ededed;
  }

  &-phone {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-license {
    padding: 30px 0 10px 30px;
    background-color: #ededed;
  }

  .upload-btn {
    width: 240px;
    height: 32px;
    background-color: #fff;
    text-align: center;
    cursor: pointer;
  }

  .license-img {
    display: flex;
    flex-wrap: wrap;

    &-list {
      line-height: 32px;
      padding: 0 10px;
      background-color: #fff;
      display: flex;
      align-items: center;
      margin-right: 10px;
      margin-bottom: 10px;

      .name {
        width: 220px;
        display: inline-block;
        overflow: hidden;
        /*超出部分隐藏*/
        white-space: nowrap;
        /*禁止换行*/
        text-overflow: ellipsis;
        /*省略号*/
      }

      span {
        color: #1890ff;
        cursor: pointer;
      }

      .line {
        width: 1px;
        height: 24px;
        background-color: #e6e6e6;
        margin: 0 6px;
      }
    }
  }

  &-export {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-scale {
    padding: 30px 0 10px 30px;
    background-color: #ededed;
  }

  &-tech {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-link {
    padding: 0 30px;
    background-color: #ededed;

    .ivu-form-item {
      margin-bottom: 0;
      line-height: 48px;

      /deep/ .ivu-form-item-label {
        font-size: 18px;
        padding: 0;
      }
    }
  }

  &-links {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-leader {
    padding: 0 30px;
    background-color: #ededed;
    position: relative;

    .ivu-form-item {
      margin-bottom: 0;
      line-height: 48px;

      /deep/ .ivu-form-item-label {
        font-size: 18px;
        padding: 0;
      }
    }

    .above {
      position: absolute;
      left: 350px;
      top: 10px;
    }
  }

  &-leaders {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-invoiceType {
    padding: 0 30px;
    background-color: #ededed;
    line-height: 48px;
    display: flex;
    justify-content: space-between;

    .ivu-checkbox-wrapper {
      margin: 0;
    }

    span {
      color: #ff0000;
      margin-left: 5px;
    }
  }

  &-invoices {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-btn {
    margin-top: 50px;
    padding-bottom: 80px;
    text-align: center;

    button {
      width: 200px;
      height: 48px;
      background-color: rgba(0, 161, 233, 1);
      font-size: 16px;
      border-color: rgba(0, 161, 233, 1);
    }
  }

  .downLoad {
    display: flex;
    align-items: center;
    margin-left: 20px;
  }
}
</style>
